import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css'],
})
export class TabsComponent implements OnInit {
  @Input() data: any;
  @Output() selectedTabChange = new EventEmitter<string>();
  selectedTab: string = '';
  constructor(private route: ActivatedRoute, private router: Router) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const typeFromParams = params['type'];

      if (
        typeFromParams &&
        this.data?.items.some((item: any) => item?.fileName === typeFromParams)
      ) {
        this.selectedTab = typeFromParams;
      } else if (this.data?.items.length > 0) {
        this.selectedTab = this.data?.items[0]?.fileName;
      }

      this.selectedTabChange.emit(this.selectedTab);
    });
  }
  selectTab(tabName: string) {
    this.selectedTab = tabName;

    this.selectedTabChange.emit(tabName);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { type: tabName },
      queryParamsHandling: 'merge',
    });
  }

  responsiveOptions = [
    { breakpoint: '992px', numVisible: 6, numScroll: 1 },
    { breakpoint: '768px', numVisible: 4, numScroll: 1 },
    { breakpoint: '576px', numVisible: 2, numScroll: 1 },
  ];
}
